import { CommonModule } from '@angular/common';
import { Component, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DpTableComponent } from '../common-component/dp-table/dp-table.component';
import { DpLoaderComponent } from '../common-component/dp-loader/dp-loader.component';
import { LoaderComponent } from '../common-component/loader/loader.component';
import { WishlistActionCellComponent } from '../table-cell/wishlist-action-cell.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MatFormField } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { AreYouUpdatedService } from '../services/raintree/Transmission/are-you-updated.service';
import { FindDetailWishListService } from '../services/common/find-detail-wishlist.shared';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { CommonUtilService } from '../services/common-util/common-util.service';
import { AppConfigService } from '../services/config/app-config.service';
import { ReviewDataService } from '../services/raintree/Transmission/review-data.service';
import { AddIdDetailsDialogComponent } from '../master-search-group/are-you-updated/add-id-details-dialog/add-id-details-dialog.component';
import { SearchService } from '../services/common/search.service';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-dp4.0',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatTooltipModule,
    DpTableComponent,
    DpLoaderComponent,
    ReactiveFormsModule,
    LoaderComponent,
    WishlistActionCellComponent,
    InfiniteScrollModule,
    MatFormField,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatIconModule,
    MatCheckboxModule
  ],
  templateUrl: './dp4.0.component.html',
  styleUrls: [
    './dp4.0.component.scss',
    '../../styles/_dropdown.scss',
  ]
})
export class Dp40Component {
  @ViewChild('tableContainer') tableContainer!: ElementRef;
  pageNo: number = 1;
  pageSize: number = 200;
  assignedList!: any[];
  tempData!: any[];
  memberName!: string;
  address!: string;
  pincode!: string;
  searchInput = new FormControl('')
  isLoader: boolean = false;
  reqBody: any = { pageNo: this.pageNo };
  showNotFound: boolean = false;
  isMobileDevice: boolean = false;
  permissionArray: string[] = [];
  selectedState: string = '';
  selectedWishlist: string = '';
  selectedDistrict: string = '';
  states: string[] = [];
  districts: { [key: string]: string[] } = {};
  allPerm: Record<string, any> = {};
  selectedPincode: any = null;
  showPinCodeData: boolean = true;
  options: any[] = [
    { id: 1, label: 'Aadhaar No Available' },
    { id: 2, label: 'Aadhaar Doc Uploaded' },
    { id: 3, label: 'PAN No Available' },
    { id: 4, label: 'PAN Doc Uploaded' }
  ];
  selectedOptions = new FormControl<any>([]);
  allowedKeys: string[] = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];
  filterForm!: FormGroup;
  searchPayLoad: any = {
    p: '',
    m: '',
    f: '',
    fw: '',
    mo: '',
    n: '',
    a: '',
  };
  breadcrumbs: string[] = ['DP 4.0'];

  @ViewChild('moreOptionsDialog') moreOptionsDialog!: TemplateRef<any>;
  showOtherCountry: boolean = false;
  showEntity: boolean = false;
  toggleFilter: boolean = false;
  noDataFound: boolean = false;
  showMigrate: boolean = false;
  constructor(
    private reviewDataService: ReviewDataService,
    private _dialog: MatDialog,
    private dialog: MatDialog,
    private _toaster: ToastrService,
    private isMobile: CommonUtilService,
    private formBuilder: FormBuilder,
    private _appConfig: AppConfigService,
    private _toastService: ToastrService,
    private _bottomSheet: MatBottomSheet,
    private findDetailsWishListService: FindDetailWishListService,
    private _areYouUpdatedService: AreYouUpdatedService,
    private _searchService: SearchService
  ) {
    this.filterForm = this.formBuilder.group({
      pincode: [''],
      name: [''],
      address: [''],

    });
  }
  fcloading: boolean = false
  resData: any[] = []
  pincodeData: any[] = [];
  wishlists: any[] = [];
  tempWishlists: any[] = [];
  wishlistId: any
  ngOnInit(): void {
    this.isLoader = true;
    this.isMobileDevice = this.isMobile.isMobileDevice();
    // this.fetchPermissions();
    this.allPerm = this._appConfig.fetchPermissionv3ByViewName();
    this.getStateList();
    this.subscribeToFormChanges();
    this.filterForm.get('pincode')?.valueChanges.subscribe((value) => {
      if (value.length > 0) this.searchPayLoad.p = value;
    });
    this.filterForm.get('address')?.valueChanges.subscribe((value) => {
      if (value.length > 0) this.searchPayLoad.a = value;
    });
    this.filterForm.get('name')?.valueChanges.subscribe((value) => {
      if (value.length > 0) this.searchPayLoad.n = value.trim();
    });
    this.searchInput.valueChanges.subscribe((value: any) => {
      if (value.length > 0)
        this.onSearch(value)
    });
    if (this.states.length > 0) {
      this.selectedState = this.states[0];
    }
    if (this.districts[this.selectedState].length > 0) {
      this.selectedDistrict = this.districts[this.selectedState][0];
    }

    this.findDetailsWishListService.setVariables(
      this.selectedState,
      this.selectedDistrict,
    );

    const selectedPincode = localStorage.getItem('selectedPincode');
    if (selectedPincode) {
      this.breadcrumbs = ['DP 4.0', `${this.selectedState}, ${this.selectedDistrict}, ${selectedPincode}`];
      this.showPinCodeData = false;
      this.selectedPincode = selectedPincode;
      this.fetchWishlishItemData(true);
      this.getAllWishlists()
    } else {
      this.fetchPincodeData(true);
    }
  }

  onBreadcrumbClick(index: number) {
    if (index === 0) {
      this.breadcrumbs = ['DP 4.0'];
      localStorage.removeItem('selectedPincode');
      this.selectedPincode = null;
      this.showPinCodeData = true;
      this.wishlistId = this.selectedWishlist = ''
      this.wishlists = this.tempWishlists = []
      this.selectedOptions.patchValue([]);
      delete this.reqBody.wishlistId;
      delete this.reqBody.isIdPresent;
      delete this.reqBody.IsDocPresent;
      this.findDetailsWishListService.setVariables(this.selectedState, this.selectedDistrict, '')
      this.fetchPincodeData(true)
    }
  }

  fetchPermissions() {
    this.permissionArray = [];
    const countryPerm = this.allPerm['INDIA'];
    if (this.selectedState != '') {
      this.permissionArray = countryPerm.allStatesPerm;
      const statePerm = countryPerm.statePerms[this.selectedState];
      if (this.selectedDistrict != '') {
        this.permissionArray = [...this.permissionArray, ...statePerm.allDistrictsPerm, ...statePerm.districtPerms[this.selectedDistrict]];
      }
    }
  }

  onSelectCriteria() {
    delete this.reqBody.isIdPresent;
    delete this.reqBody.IsDocPresent;
    const selectedCriteriaId = this.selectedOptions?.value?.id;
    if (selectedCriteriaId === 1) this.reqBody['isIdPresent'] = 'aadhar';
    else if (selectedCriteriaId === 2) this.reqBody['IsDocPresent'] = 'aadhar';
    else if (selectedCriteriaId === 3) this.reqBody['isIdPresent'] = 'pan';
    else if (selectedCriteriaId === 4) this.reqBody['IsDocPresent'] = 'pan';

    this.fetchWishlishItemData(true);
  }

  getStateList() {
    const countryPerm = this.allPerm['INDIA'];
    if (countryPerm.allStatesPerm.length > 0) {
      // fetch all States (not required for assigned list)
    }
    else {
      Object.entries(countryPerm.statePerms).forEach(([state, stateData]: any) => {
        this.states.push(state);
        this.districts[state] = [];
        if (stateData.allDistrictsPerm.length > 0) {
          // fetch all Districts (not required for assigned list)
        }
        else {
          Object.entries(stateData.districtPerms).forEach(([district, districtData]) => {
            this.districts[state].push(district);
          })
        }
      })
    }

  }
  getAllWishlists() {
    // this.fcloading = true
    this.reviewDataService.fetchUserWiseWishlistItems({ pinCode: this.selectedPincode }).subscribe({
      next: (res: any) => {
        this.wishlists = this.tempWishlists = res.data
        // this.fcloading = false
      }, error: (err: any) => {
        // this.fcloading = false
        this._toastService.error(err)
      }
    })
  }
  fetchPincodeData(isStart: boolean) {
    this.reviewDataService
      .fetchPinCode(this.selectedState, this.selectedDistrict)
      .subscribe({
        next: (response) => {
          this.isLoader = false;
          if (response.data.length > 0) {
            this.pincodeData = response.data;
            this.pincodeData.push({
              "pincode": "Unknown"
            })
          }
        },
        error: (error) => {
          this.isLoader = false;
          console.log(error);
        },
      });
    // this._namesToUpdateService.fetchAssignData(this.reqBody).subscribe({
    //   next: (response: any) => {
    //     this.isLoader = false;
    //     const transformedData: any[] = response.data.map(
    //       (item: any) => ({
    //         ...item,
    //         isExpanded: false,
    //       })
    //     );
    //     this.assignedList = [...this.assignedList, ...transformedData];
    //     this.tempData = this.assignedList;
    //   },
    //   error: (error) => {
    //     this._toastService.error(error);
    //     this.isLoader = false;
    //   },
    // });
  }

  onRowClick(selectedRow: any) {
    if (!this.showPinCodeData) {
      return;
    }
    this.selectedOptions.patchValue([]);
    delete this.reqBody.isIdPresent;
    delete this.reqBody.IsDocPresent;
    this.breadcrumbs.push(`${this.selectedState}, ${this.selectedDistrict}, ${selectedRow.pincode}`);
    localStorage.setItem('selectedPincode', selectedRow.pincode);
    this.selectedPincode = selectedRow.pincode;
    this.fetchWishlishItemData(true);
    this.getAllWishlists()
  }

  fetchWishlishItemData(isStart: boolean) {
    if (this.selectedState == '') {
      this.noDataFound = true;
      return;
    }
    if (isStart) {
      this.assignedList = this.tempData = [];
      this.pageNo = 1;
    } else {
      this.pageNo += 1;
    }
    this.reqBody['pageNo'] = this.pageNo;
    this.reqBody['uiState'] = this.selectedState;
    if (this.selectedDistrict != '')
      this.reqBody['uiDistrict'] = this.selectedDistrict;
    if (this.selectedPincode != '') this.reqBody['pincode'] = this.selectedPincode

    if (this.wishlistId && this.wishlistId != '')
      this.reqBody['wishlistId'] = this.wishlistId
    this.showPinCodeData = false;
    this.pageNo > 1 ? this.isLoader = true : this.fcloading = true
    this.reviewDataService.fetchWishlistItemList(this.reqBody).subscribe({
      next: (response: any) => {
        this.assignedList = [...this.assignedList, ...response.data];
        this.tempData = this.assignedList;

        this.fcloading = false;
        this.isLoader = false
      },
      error: (error) => {
        this._toastService.error(error);
        this.fcloading = this.isLoader = false;
      },
    });
  }

  openDialog(row: any) {
    const rowData = {
      "rowData": {
        "add": row.addr,
        "st": row.dpUpdatedState,
        "rs": row.recordStatus,
        "lid": row.livDate,
        "sau": "",
        "gln": "",
        "dn": row.dist,
        "gfn": "",
        "pmn": "",
        "fw": "",
        "sgg": "",
        "mc": row.memberCode,
        "md": "",
        "pms": "",
        "sgm": "",
        "dau": "",
        "rn": "",
        "fc": row.fc,
        "mk": row.serialNo,
        "pn": row.pin,
        "po": "",
        "lastIvDate": row.livDate,
        "philName": "",
        "memberName": row.mNm,
        "stateCode": "",
        "adharSubmitted": row.adhar ? true : false,
        "adharNo": (row.adhar ? row.adhar : null),
        "adharUploaded": row.adhar ? true : false,
        "panNo": row.pan ? row.pan : null,
        "panUploaded": row.pan ? true : false,
        "panSubmitted": row.pan ? true : false,
        "contactNo": row.contactNo
      },
      "addId": true
    }
    const dialogRef = this.dialog.open(AddIdDetailsDialogComponent, { data: rowData, width: '500px' });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // this.assignedList.filter(item => item.memberCode === row.memberCode);
        // this.tempData = this.assignedList;
        this.assignedList = this.assignedList.filter(item => item.memberCode !== row.memberCode);
        this.tempData = [...this.assignedList]; // create a new reference so Angular detects change
        row.isDisabled = true;

        // rowData.docSubmitted=true;
        // rowData.docUploaded='Yes';
      }
    });
  }

  collapseRow(event: MouseEvent, row: any) {
    event.stopPropagation();
    row.isExpanded = false;
  }

  // onSearchMemberName(event: string) {
  //   this.assignedList = this.tempData;
  //   if (event != '') {
  //     this.assignedList = this.assignedList.filter((record) =>
  //       record.mNm?.toLowerCase().includes(this.memberName?.toLowerCase())
  //     );
  //   } else {
  //     this.assignedList = this.tempData;
  //   }
  // }

  // onSearchAddressName(event: string) {
  //   this.assignedList = this.tempData;
  //   if (event != '') {
  //     this.assignedList = this.assignedList.filter((record) =>
  //       record.addr?.toLowerCase().includes(this.address?.toLowerCase())
  //     );
  //   } else {
  //     this.assignedList = this.tempData;
  //   }
  // }

  subscribeToFormChanges() {
    this.filterForm.get('name')?.valueChanges.subscribe((value) => {
      if (value) {
        this.filterForm.get('address')?.reset();
        this.filterForm.get('pincode')?.reset();
      }
    });

    this.filterForm.get('address')?.valueChanges.subscribe((value) => {
      if (value) {
        this.filterForm.get('name')?.reset();
        this.filterForm.get('pincode')?.reset();
      }
    });

    this.filterForm.get('pincode')?.valueChanges.subscribe((value) => {
      if (value) {
        this.filterForm.get('name')?.reset();
        this.filterForm.get('address')?.reset();
      }
    });
  }

  // onSearchClick() {
  //   this.isLoader = true;
  //   const name = this.filterForm.get('name')?.value;
  //   const address = this.filterForm.get('address')?.value;
  //   const pincode = this.filterForm.get('pincode')?.value;
  //   setTimeout(() => {
  //     this.assignedList = this.tempData.filter(
  //       (record: any) => {
  //         const recordName = record.mNm?.toLowerCase() || '';
  //         const recordAddress = record.addr?.toLowerCase() || '';
  //         const recordPincode = record.pin?.toLowerCase() || '';

  //         return (
  //           recordName.includes(name) ||
  //           recordAddress.includes(address) ||
  //           recordPincode.includes(pincode)
  //         );
  //       }
  //     );
  //     this.isLoader = false;
  //   }, 2000);
  // }
  onSearch(value: any) {
    this.assignedList = this.tempData
    if (value.length >= 3) {
      this.assignedList = this._searchService.fuseFilterData(
        this.tempData,
        value,
        ['mNm']
      );
    }
  }
  restrictNameInput(event: KeyboardEvent): void {
    const input = event.key;

    const pattern = /^[a-zA-Z\s]+$/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (!pattern.test(input)) {
      event.preventDefault();
    }
  }

  restrictNumberInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;
    const pattern = /[0-9]/;

    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (!pattern.test(input) || limit.value.length > 5) {
      event.preventDefault();
    }
  }

  closeMoreOptionsDialog() {
    this.dialog.closeAll();
  }

  onStateChange() {
    this.selectedDistrict = this.districts[this.selectedState][0]
    this.findDetailsWishListService.setVariables(
      this.selectedState,
      this.selectedDistrict
    );
    this.fetchPermissions();
  }

  clearStateSelection() {
    this.selectedState = '';
    this.selectedDistrict = '';
    this.fetchPermissions();
  }
  clearDistrictSelection() {
    this.selectedDistrict = '';
    this.fetchPermissions();
  }
  clearWishlistSelection() {
    this.selectedWishlist = '';
    this.findDetailsWishListService.setVariables(this.selectedState, this.selectedDistrict, '')
    delete this.reqBody.wishlistId

    this.fetchWishlishItemData(true)
  }
  clearCriteria() {
    this.selectedOptions.patchValue([]);
    delete this.reqBody.isIdPresent;
    delete this.reqBody.IsDocPresent;
    this.fetchWishlishItemData(true);
  }
  onDistrictChange() {
    this.fetchPincodeData(true);
    this.findDetailsWishListService.setVariables(
      this.selectedState,
      this.selectedDistrict
    );
    this.fetchPermissions();
  }
  onwishlistSelect(wl: any) {
    this.wishlistId = wl.wishlist_id
    this.fetchWishlishItemData(true)
    this.findDetailsWishListService.setVariables(
      this.selectedState,
      this.selectedDistrict, this.wishlistId
    );
  }
  onWishlistChange(event: any) {
    this.wishlists = this.tempWishlists
    if (event.length > 0) {
      this.wishlists = this.wishlists.filter((item: any) => item.wishlist_name.toLowerCase().includes(event.toLowerCase()))
    } else {
      this.selectedWishlist = '';
      this.findDetailsWishListService.setVariables(this.selectedState, this.selectedDistrict, '')
      delete this.reqBody.wishlistId
      this.wishlistId = ''
      this.fetchWishlishItemData(true)
    }
  }
}
